<template>
<div v-if="pageData" class="c-mv3" :class="{'c-mv3--photo-right': isPhotoRight }">
  <div class="c-mv3__main">
    <span class="is-shape" :style="styleShape"></span>
    <img :src="pageData.photo.src" alt="" width="750" height="990" />
  </div>
  <div class="c-mv3__info">
    <h2 v-if="pageData.info.title" :class="{'is-blend': isBlend}" :style="{'color': colorCode}">
      <span v-for="line in pageData.info.title" :key="line">
        <span class="is-line">{{line}}</span>
      </span>
    </h2>
    <div class="is-text">
      <p v-html="pageData.info.text"></p>
      <a v-if="pageData.modal" class="c-btnView" href="#" @click.prevent="openModal">
        <span>VIEW MORE</span>
      </a>
    </div>
  </div>
</div>
</template>

<script>
import {gsap, Power3, Expo} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
      shapeSize: 990 / 750 * 100,
      isPhotoRight: false,
      isBlend: false,
      colorCode: '',
    }
  },
  props: ['name'],
  computed: {
    styleShape() {
      return {paddingTop: `${this.shapeSize}%`};
    }
  },
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // 写真のレイアウトclass
    this.isPhotoRight = (this.pageData.photo.layout === 'right');

    // 画像
    const img = new Image();
    img.onload = () => {
      this.loaded({width: img.width, height: img.height});
    }
    img.src = this.pageData.photo.src;

    // タイトル文字色設定
    if (this.pageData.info.color) {
      this.colorCode = `#${this.pageData.info.color}`;
    } else {
      this.isBlend = true;
    }
  },
  methods: {
    once() {
      // 画像表示
      const photo = this.$el.querySelector('.c-mv3__main img');
      let viewPhoto = gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: 'top 90%',
          end: 'top 10%',
          once: true,
          // scrub: true,
          // markers: true,
        }
      });
      viewPhoto.addLabel('start')
      .fromTo(photo, {
        scale: 1.3,
      }, {
        duration: 1.0,
        scale: 1,
        ease: Power3.easeOut,
      }, 'start')
      .fromTo(photo, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Power3.easeOut,
      }, 'start+=0.1');

      // テキスト表示
      const blockText = this.$el.querySelector('.c-mv3__info');
      const lines = blockText.querySelectorAll('.is-line');
      const texts = blockText.querySelector('.is-text');

      let viewText = gsap.timeline({
        scrollTrigger: {
          trigger: blockText,
          start: 'top 70%',
          end: 'top 40%',
          once: true,
          // scrub: 0.7,
          // markers: true,
        }
      });
      
      if (lines.length > 0) {
        viewText.addLabel('start')
        .fromTo(lines, {
          opacity: 0,
          y: '20%',
        }, {
          duration: 1.0,
          opacity: 1,
          y: '0%',
          ease: Power3.easeOut,
          stagger: 0.1,
        }, 'start')
        .fromTo(texts, {
          opacity: 0,
          y: '20%',
        }, {
          duration: 1.0,
          opacity: 1,
          y: '0%',
          ease: Power3.easeOut,
        }, 'start+=0.2');
      } else {
        viewText.addLabel('start')
        .fromTo(texts, {
          opacity: 0,
          y: '20%',
        }, {
          duration: 1.0,
          opacity: 1,
          y: '0%',
          ease: Power3.easeOut,
        }, 'start');
      }
    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    loaded(e) {
      this.shapeSize = e.height / e.width * 100;
      this.$nextTick(this.once);
    },
  }
}
</script>